import {EtsyListing, EtsyListingImage, etsySettings} from '@coolcolduk/etsy';
import {padArray} from '@coolcolduk/util';
import dayjs from 'dayjs';
import {unescape} from 'lodash';
import {ETSY_BULK_CREATE_CSV_HEADER} from './getEtsyBulkCreateCsvHeader';
import saveAsCsv from './saveAsCsv';

export function downloadCreateListingCsv(etsyListings: EtsyListing[]) {
  const csvRows = etsyListings.map((listing) => {
    const tags = padArray(listing.tags || [], '', etsySettings.listing.tags.maxCount, false);
    const imageUrls = padArray(
      listing.images || [],
      {url_fullxfull: ''} as EtsyListingImage,
      etsySettings.listing.image.maxNumber,
      false,
    );
    return [
      `"${unescape(listing.title)}"`,
      ...tags.map((tag) => `"${tag}"`),
      ...imageUrls.map((imageUrl) => `"${imageUrl.url_fullxfull}"`),
    ];
  });

  saveAsCsv([ETSY_BULK_CREATE_CSV_HEADER, ...csvRows], `etsy_bulk_create_${dayjs().format('YYYY-MM-DD HH_mm_ss')}.csv`);
}
